document.querySelectorAll('[data-cn-cookie-controls]').forEach(function (root) {
  var button = root.querySelector('[data-cn-cookie-settings]');
  var status = root.querySelector('[data-cn-cookie-status]');
  if (!button || !status) return;
  var pendingFocus = null;
  var dismissOpener = null;
  var dismissBanner = null;
  var canDismissRenewal = false;
  var savedResponseKnown = false;
  var cancelAction = null;
  var renewalObserver = null;
  function bannerVisible(banner) {
    if (!banner || !banner.isConnected || !banner.getClientRects().length) return false;
    var style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }
  // Move focus only after this page's explicit renewal action. Automatic
  // banners and people who moved elsewhere keep their current focus.
  window.addEventListener('CookiebotOnDialogDisplay', function () {
    var opener = pendingFocus || dismissOpener;
    pendingFocus = null;
    var banner = document.getElementById('CybotCookiebotDialog');
    dismissOpener = opener && canDismissRenewal ? opener : null;
    dismissBanner = dismissOpener ? banner : null;
    if (dismissOpener && !renewalObserver) {
      // The provider reconstructs its buttons after the display event. Follow
      // the current banner only while this explicit renewal remains active.
      renewalObserver = new MutationObserver(prepareCancelAction);
      renewalObserver.observe(document.body, { childList: true, subtree: true });
    }
    prepareCancelAction();
    if (!opener || document.activeElement !== opener) return;
    if (!banner) return;
    var controls = banner.querySelectorAll('a[href], button, input, select, textarea, [tabindex]');
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      if (control.disabled || control.tabIndex < 0 || !control.getClientRects().length) continue;
      var style = window.getComputedStyle(control);
      if (style.visibility === 'hidden' || style.display === 'none') continue;
      control.focus();
      break;
    }
  });
  function prepareCancelAction() {
    if (!dismissOpener) return;
    if (!dismissOpener.isConnected) { clearDismissal(); return; }
    var banner = document.getElementById('CybotCookiebotDialog');
    dismissBanner = banner;
    if (cancelAction && cancelAction.isConnected && banner?.contains(cancelAction)) return;
    if (cancelAction) cancelAction.remove();
    cancelAction = null;
    var accept = banner && banner.querySelector('#CybotCookiebotDialogBodyButtonAccept');
    if (!accept || !window.Cookiebot || typeof window.Cookiebot.hide !== 'function') return;
    cancelAction = document.createElement('button');
    cancelAction.type = 'button';
    cancelAction.className = 'cn-cookie-renewal-cancel';
    cancelAction.setAttribute('data-cn-cookie-renewal-cancel', '');
    cancelAction.textContent = 'Keep current choices';
    cancelAction.addEventListener('click', dismissRenewal);
    accept.parentNode.insertBefore(cancelAction, accept);
  }
  function clearDismissal() {
    if (renewalObserver) renewalObserver.disconnect();
    renewalObserver = null;
    if (cancelAction) cancelAction.remove();
    cancelAction = null;
    dismissOpener = null;
    dismissBanner = null;
    canDismissRenewal = false;
  }
  function responseChanged() {
    // Accept/decline also run for loaded responses; withdrawal emits decline
    // with hasResponse false. Never retain a response after that withdrawal.
    savedResponseKnown = !!window.Cookiebot && window.Cookiebot.hasResponse === true;
    clearDismissal();
  }
  window.addEventListener('CookiebotOnAccept', responseChanged);
  window.addEventListener('CookiebotOnDecline', responseChanged);
  window.addEventListener('pagehide', clearDismissal);
  function dismissRenewal() {
    var opener = dismissOpener;
    var banner = dismissBanner;
    var provider = window.Cookiebot;
    if (!opener || !bannerVisible(banner) || !provider || typeof provider.hide !== 'function') return false;
    try {
      // Cancel only this explicit renewal of a previously submitted response.
      // The documented hide method never submits or withdraws a choice.
      provider.hide();
    } catch (error) {
      status.textContent = 'Cookie choices could not close. Please use the choices above, or try again.';
      status.hidden = false;
      return false;
    }
    clearDismissal();
    var attempts = 0;
    function afterHide() {
      if (bannerVisible(banner)) {
        if (++attempts < 30) window.requestAnimationFrame(afterHide);
        return;
      }
      var active = document.activeElement;
      // Respect anyone who moved to another page control during dismissal.
      if (opener.isConnected && (active === document.body || banner.contains(active))) opener.focus();
    }
    window.requestAnimationFrame(afterHide);
    return true;
  }
  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || event.defaultPrevented || !dismissBanner?.contains(event.target)) return;
    if (dismissRenewal()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  button.hidden = false;
  button.addEventListener('click', function () {
    status.hidden = true;
    try {
      if (!window.Cookiebot || typeof window.Cookiebot.renew !== 'function') {
        throw new Error('Cookie choices unavailable');
      }
      clearDismissal();
      pendingFocus = button;
      // renew() clears the SDK's runtime flag. Remember only a response known
      // before renewal so repeated cancellation still preserves saved choices.
      if (window.Cookiebot.hasResponse === true) savedResponseKnown = true;
      canDismissRenewal = savedResponseKnown && (window.Cookiebot.hasResponse === true || window.Cookiebot.consented === true || window.Cookiebot.declined === true);
      window.Cookiebot.renew();
    } catch (error) {
      pendingFocus = null;
      clearDismissal();
      status.textContent = 'Cookie choices could not open. Please try again, or contact us using the email below.';
      status.hidden = false;
    }
  });
  var page = root.closest('.cn-cookie-page');
  if (!page) return;
  function prepareTables() {
    page.querySelectorAll('.CookieDeclarationTable').forEach(function (table) {
      if (table.closest('.cn-cookie-table-scroll')) return;
      var category = table.closest('.CookieDeclarationType');
      var heading = category && category.querySelector('.CookieDeclarationTypeHeader');
      var label = heading ? heading.textContent.trim().replace(/\s+/g, ' ') : 'Cookies';
      var help = document.createElement('p');
      help.className = 'cn-cookie-table-help';
      help.textContent = 'Swipe or use the arrow keys to view all columns.';
      var scroll = document.createElement('div');
      scroll.className = 'cn-cookie-table-scroll';
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', label + ' cookie details');
      scroll.tabIndex = 0;
      table.parentNode.insertBefore(help, table);
      table.parentNode.insertBefore(scroll, table);
      scroll.appendChild(table);
    });
  }
  prepareTables();
  new MutationObserver(prepareTables).observe(page, { childList: true, subtree: true });
});
